import axios from 'axios';
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  allLessons: "Lessons/list",
  myLessons: "Lessons/my-lessons",
  lessonDetails: "Lessons/",
  enroll: "Lessons/access-code",
  streamVideo: "Lessons/stream/",
};

 export const createLessonAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/" + endpoint + "";
    console.log("BASE_URL:", BASE_URL);
    console.log("Endpoint:", endpoint);
    console.log("URL:", url);


  const token = sessionStorage.getItem("token");
  return {
    fetch: () =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    fetchById: (id) =>
      axios.get(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    post: (newRecord) => axios.post(url, newRecord),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
}